import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import { CreateBudgetProgress } from './CreateBudgetProgress';

/**
 * @todo
 * The quality of this component could be improved.
 * Future improvement work should consider refactoring.
 */
class CreateBudgetHeaderMobile extends Component {
  constructor(props) {
    super(props);

    this._closeModalFlag = this._closeModalFlag.bind(this);
    this._modalFlag = this._modalFlag.bind(this);

    this.state = {
      showModal: false,
    };
  }

  _closeModalFlag() {
    this.props._removeclassname();
    this.setState({ showModal: false }, () => {});
  }

  _modalFlag() {
    this.props._addclassname();
    this.setState({ showModal: true }, () => {});
  }

  render() {
    const content = this.props.content;
    const totalBudgetValue = this.props.totalBudgetValue;
    const potValue = this.props.potValue;
    const earning = this.props.earning;

    const budgetValue = Math.abs(totalBudgetValue - potValue);
    const sortValue = Math.abs(totalBudgetValue - earning);
    let mainMessage;
    let message;
    let modal;
    let modalMessage;
    if (Number(earning) - Number(totalBudgetValue) < 0) {
      mainMessage = (
        <div className="spendings-message spendings-message-rejig">
          <h5>
            <span className="icon icon-information" />
            {content.spendingCreateMessageTitleText2}
          </h5>
        </div>
      );
      message = (
        <p>
          {content.spendingCreateMessageCopyText7}{' '}
          <span className="sortValue">
            <b>{NumberUtils.appendCurrency('{}', sortValue)}</b>
          </span>
        </p>
      );
      modalMessage = (
        <p>
          {content.spendingCreateMessageCopyText8}{' '}
          <b>{NumberUtils.appendCurrency('{}', budgetValue)}</b>
          {content.spendingCreateMessageCopyText2}{' '}
          <b>{NumberUtils.appendCurrency('{}', potValue)}</b>.
        </p>
      );
    } else {
      mainMessage = (
        <div className="spendings-message">
          <h5>{content.spendingCreateMessageTitleText1}</h5>
        </div>
      );
      message = (
        <p>
          {content.spendingCreateMessageCopyText6}{' '}
          <b>{NumberUtils.appendCurrency('{}', sortValue)}</b>{' '}
          {content.spendingCreateMessageCopyText9}
        </p>
      );
      modalMessage = (
        <p>
          {content.spendingCreateMessageCopyText8}{' '}
          <b>{NumberUtils.appendCurrency('{}', budgetValue)}</b>
          {content.spendingCreateMessageCopyText2}{' '}
          <b>{NumberUtils.appendCurrency('{}', potValue)}</b>.
        </p>
      );
    }
    if (this.state.showModal) {
      modal = (
        <div className="modal-message">
          {modalMessage}
          <div className="spendings-progress mobile-progressbar">
            <CreateBudgetProgress
              content={content}
              totalBudgetValue={totalBudgetValue}
              potValue={potValue}
              earning={earning}
            />
          </div>
          <button
            type="button"
            className="btn btn-link text-center"
            onClick={this._closeModalFlag}
          >
            Close
          </button>
        </div>
      );
    } else {
      modal = (
        <button
          type="button"
          className="btn btn-link text-center"
          onClick={this._modalFlag}
        >
          {content.spendingCloserLook}
        </button>
      );
    }
    return (
      <div className="text-center spendings-createbudget-message">
        {mainMessage}
        <div className="budget-boxes">
          <article>
            <section className="text-center">
              <h6>Budget</h6>
              <h4>{NumberUtils.appendCurrency('{}', Number(budgetValue))}</h4>
            </section>
          </article>
          <article>
            <section
              className="text-center budget"
              onClick={this.props._handleEarnings}
            >
              <h6>Earnings</h6>
              <h4>{NumberUtils.appendCurrency('{}', Number(earning))}</h4>
            </section>
          </article>
        </div>
        <div className="outer-message">
          {message}
          {modal}
        </div>
      </div>
    );
  }
}

CreateBudgetHeaderMobile.propTypes = {
  content: PropTypes.object,
  totalBudgetValue: PropTypes.number,
  potValue: PropTypes.number,
  earning: PropTypes.number,
  _handleEarnings: PropTypes.func,
  _removeclassname: PropTypes.func,
  _addclassname: PropTypes.func,
};

export { CreateBudgetHeaderMobile };
